import * as React from 'react';
import * as cn from 'classnames';
const InputMask = require('react-input-mask');
import * as styles from './styles.css';

import { Button } from '@cian/ui-kit/button';

import { NBSP } from '../../../constants/symbols';

import { IconError } from './icons';
import { clearPhone, getMask } from './utils';
import { Text } from '../../Text';
import { ISendFeedbackParams } from '../../../types/redux';

import { trackFirstInteractionForm } from '../tracking';

export interface IName {
  name: string;
  nameError?: boolean;
}

export interface IPhone {
  phone: string;
  phoneError?: boolean;
}

export interface IComment {
  comment: string;
  commentError?: boolean;
}

export interface IFormProps {
  isLoading: boolean;
  isSendError: boolean;
  sendForm(params: ISendFeedbackParams): void;
}

interface IHandleSubmitParams {
  name: string;
  phone: string;
  comment: string;
  setName(param: IName): void;
  setPhone(param: IPhone): void;
  setComment(param: IComment): void;
  sendForm(params: ISendFeedbackParams): void;
}

function handleSubmit(e: React.FormEvent, params: IHandleSubmitParams) {
  e.preventDefault();

  const { name, phone, comment, setName, setPhone, setComment, sendForm } = params;
  const sanitizePhone = clearPhone(phone);

  if (!name) {
    setName({ name, nameError: true });

    return;
  }

  if (sanitizePhone.length < 12) {
    setPhone({ phone, phoneError: true });

    return;
  }

  if (!comment.trim()) {
    setComment({ comment, commentError: true });

    return;
  }

  sendForm({ name, phone: sanitizePhone, comment });
}

export function Form({ sendForm, isLoading, isSendError }: IFormProps) {
  const [{ name, nameError }, setName] = React.useState<IName>({ name: '' });
  const [{ phone, phoneError }, setPhone] = React.useState<IPhone>({ phone: '' });
  const [{ comment, commentError }, setComment] = React.useState<IComment>({ comment: '' });
  const [interacted, setInteracted] = React.useState(false);

  /**
   * Отправка события "первое взаимодействие с формой"
   * @param cb функция для установки значения в input
   */
  const setValue = (cb: () => void) => {
    cb();

    if (!interacted) {
      trackFirstInteractionForm();

      setInteracted(true);
    }
  };

  return (
    <form
      action="#"
      className={styles['form']}
      onSubmit={e => handleSubmit(e, { name, phone, comment, setName, setPhone, setComment, sendForm })}
    >
      <div className={cn(styles['row'], styles['inputs'])}>
        <div className={styles['field']}>
          {nameError && <IconError />}
          <input
            className={cn(nameError && styles['input-invalid'])}
            placeholder="Ваше имя*"
            value={name}
            onChange={e => setValue(() => setName({ name: e.currentTarget.value, nameError: false }))}
          />
        </div>
        <div className={styles['field']}>
          {phoneError && <IconError />}
          <InputMask
            className={cn(phoneError && styles['input-invalid'])}
            placeholder="Мобильный телефон*"
            mask={getMask(phone)}
            maskChar=" "
            value={phone}
            // SyntheticEvent не подошел, пока оставил any
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(e: any) => setValue(() => setPhone({ phone: clearPhone(e.target.value), phoneError: false }))}
          />
        </div>
      </div>
      <div className={cn(styles['row'], styles['comment'])}>
        {commentError && <IconError />}
        <textarea
          className={cn(commentError && styles['input-invalid'])}
          placeholder="Комментарий"
          value={comment}
          onChange={e => setValue(() => setComment({ comment: e.currentTarget.value, commentError: false }))}
          rows={5}
        />
      </div>
      {isSendError && (
        <div className={styles['error-text']}>
          <Text color="white">Ошибка сервера. Попробуйте еще раз, либо{NBSP}зайдите попозже</Text>
        </div>
      )}
      <div className={cn(styles['row'], styles['feedback-button'])}>
        <Button type="submit" theme="fill_white_secondary" size="M" loading={isLoading}>
          Отправить заявку
        </Button>
        <div />
      </div>
    </form>
  );
}
